import generateUtilityClasses from '@mui/material/generateUtilityClasses';
import { baseSelectMenuClasses } from '../SelectMenuUtils/BaseSelectMenu/baseSelectMenuClasses';

const baseMultiSelectMenuClasses = generateUtilityClasses('AFMultiSelectMenu', [
  'multiSelectWrapper',
  'extraInfoRoot'
]);
export const multiSelectMenuClasses = {
  ...baseMultiSelectMenuClasses,
  ...baseSelectMenuClasses
};
